import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { MobileGlobalStaffStore } from '@ew-mobile/mobile-staff-store';

export const mobileStaffAuthGuard: CanActivateFn = () => {
  const staffStore = inject(MobileGlobalStaffStore);
  const router = inject(Router);

  if (staffStore.isAuthenticated()) {
    return true;
  }

  router.navigate(['/staff/login']);
  return false;
};
